module.exports = __webpack_public_path__ + "img/google.639806f5.svg";